@if (isExternalQuoteCheckoutEnabled$ | async) {
  <app-guest-cart></app-guest-cart>
} @else {
  <app-multi-cart
      [isExportCartActive]="isExportCartActive$ | async">
  </app-multi-cart>
}
